// WARNING: DO NOT EDIT. This file is Auto-Generated by AWS Mobile Hub. It will be overwritten.

// Copyright 2017-2018 Amazon.com, Inc. or its affiliates (Amazon). All Rights Reserved.
// Code generated by AWS Mobile Hub. Amazon gives unlimited permission to
// copy, distribute and modify it.

// AWS Mobile Hub Project Constants
const awsmobile = {
    'aws_app_analytics': 'enable',
    'aws_cognito_identity_pool_id': 'us-east-1:19cdf682-ce7d-4e87-aab5-27584d7bc0a4',
    'aws_cognito_region': 'us-east-1',
    'aws_content_delivery': 'enable',
    'aws_content_delivery_bucket': 'weatherstationawsmob-hosting-mobilehub-1023766614',
    'aws_content_delivery_bucket_region': 'us-east-1',
    'aws_content_delivery_cloudfront': 'enable',
    'aws_content_delivery_cloudfront_domain': 'd2mlhx8sbcg8bi.cloudfront.net',
    'aws_mobile_analytics_app_id': '197db522a4b847d89276e086e9de40e8',
    'aws_mobile_analytics_app_region': 'us-east-1',
    'aws_project_id': '96f7dd05-00ef-4837-8ca1-7751d169b02c',
    'aws_project_name': 'weather-station-awsmobile',
    'aws_project_region': 'us-east-1',
    'aws_resource_name_prefix': 'weatherstationawsmob-mobilehub-1023766614',
    'aws_sign_in_enabled': 'enable',
    'aws_user_files': 'enable',
    'aws_user_files_s3_bucket': 'weatherstationawsmob-userfiles-mobilehub-1023766614',
    'aws_user_files_s3_bucket_region': 'us-east-1',
    'aws_user_pools': 'enable',
    'aws_user_pools_id': 'us-east-1_Lr4YrqPnO',
    'aws_user_pools_mfa_type': 'ON',
    'aws_user_pools_web_client_id': '58vg2101tdrarvqr3q1o4et8fc',
}

export default awsmobile;



// WEBPACK FOOTER //
// ./awsmobilejs/#current-backend-info/aws-exports.ts